import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const isHotel = location.pathname.includes('/hotels/');



  return (
    <header className="lil-w-full lil-font-goldplay">
      <nav className="lil-bg-[#0f0013] lil-py-4 lil-shadow-md">
        <div className="lil-max-w-7xl lil-mx-auto lil-flex lil-justify-between lil-items-center lil-px-4">

          <div className="lil-flex lil-flex-col md:lil-flex-row lil-items-center lil-gap-10">

          <a href="https://www.toulouse.aeroport.fr/" className="lil-flex-1 lil-flex lil-justify-start  ">
            <img
              src="https://img-assets.bookfhr.com/logo-white-atbxbdv.jpg"
              alt="Aéroport Toulouse Blagnac feat bdv"
              className="lil-h-10 md:lil-h-[65px]"
              />
         
          </a>
                    {isHotel && (
                      <p className="lil-text-white lil-text-lg lil-text-center">Réservation d’hôtels</p>
                    )}

                    </div>
  
        
         

           
          <div className="lil-flex lil-flex-col lil-items-end lil-text-white lil-text-sm"> 
            <span className="lil-flex lil-items-center lil-cursor-pointer" onClick={() => window.location.href = 'tel:0899493212'}>
              <i className="fas fa-phone lil-mr-2 lil-text-md md:lil-text-lg"></i>
              <b className="lil-text-md md:lil-text-lg">08 99 49 32 12</b>
            </span>
            <span className="lil-text-xs">0.80 €/min</span>
          </div>

        </div>
      </nav>
    </header>
  );
};

export default Header; 